import {
    LOAD_SUBSCRIPTIONS,
    LOAD_SUBSCRIPTIONS_FAILURE,
    LOAD_SUBSCRIPTIONS_SUCCESS,
} from '../actions';

const initialState = {
    fetching: false,
    error: undefined,
    content: [],
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_SUBSCRIPTIONS:
            return {
                ...state,
                error: undefined,
                fetching: true,
            };
        case LOAD_SUBSCRIPTIONS_FAILURE:
            return {
                ...state,
                error: action.payload,
                fetching: false,
            };
        case LOAD_SUBSCRIPTIONS_SUCCESS:
            return {
                ...state,
                fetching: false,
                error: undefined,
                content: action.payload.content,
                meta: action.payload.meta,
            };
        default:
            return state;
    }
};

export default reducer;
